import React from "react";
import { ReactComponent as MicIcon } from 'assets/mic.svg';
import styles from './DeepgramS2T.module.scss';
import Speech2Text from "../SpeechRecognition";
import DeepgramT2S from "../DeepgramT2S/DeepgramT2S";
import { voiceModeLocalStorage } from "stores/Localstorage";
import { observer } from "mobx-react";
import { store } from "stores/Store";
import { InterruptControllerRef } from "components/InterruptController/InterruptController";
/* Add text to speech API */

interface IVoiceInput {
  setLoading: (loading: boolean) => void;
  handleSubmit: any;
  waitingResponse: boolean;
  hidden: boolean;
  setIsVoicePlaying: (isVoicePlaying: boolean) => void;
  isVoicePlaying: boolean;
  interruptControllerRef: React.MutableRefObject<InterruptControllerRef | null>;
}

const DeepgramS2T: React.FC<IVoiceInput> = observer(
  ({ handleSubmit, waitingResponse, hidden, setLoading, setIsVoicePlaying, isVoicePlaying, interruptControllerRef }) => {
    const [enabled, setEnabled] = React.useState(false);
    const [isFirstMsg, setIsFirstMsg] = React.useState(true);

    const audioCtxRef = React.useRef<AudioContext | null>(null);
    const [unlocked, setUnlocked] = React.useState(false);    

    const audioRef = React.useRef<HTMLAudioElement>(null);
    const voiceMode = React.useRef((voiceModeLocalStorage.get() as any)?.value);

    
    // Silent‐buffer unlock routine
    const unlockAudio = async () => {
      audioCtxRef.current = new (window.AudioContext || (window as any).webkitAudioContext)();
      await audioCtxRef.current.resume();
      const buf = audioCtxRef.current.createBuffer(1, 1, 22050);
      const src = audioCtxRef.current.createBufferSource();
      src.buffer = buf;
      src.connect(audioCtxRef.current.destination);
      src.start(0);
      setUnlocked(true);
      console.log("Playing unheard buffer and unlocking for the first time.");
    };



    // Combined handler: first unlock audio (once), then toggle mic
    const handleMicClick = async () => {
      if (!unlocked) {
        await unlockAudio();
      }
      setEnabled(e => !e);
      // play the “mic on/off” click if you like
      audioRef.current?.play().catch(() => {/* ignore */});
    };

    React.useEffect(() => {
      if (enabled) {
        setIsFirstMsg(true);
      }
    }, [enabled]);    

    
    React.useEffect(() => {
      if(waitingResponse) {
        setIsFirstMsg(false);
        
        // to keep the stop button up while speech not started
        if(voiceMode.current === 'VOICE') {
          setIsVoicePlaying(true);
        }
      }
    }, [store.answers.length])

    const renderContent = () => {
      if (waitingResponse)
        return <></>;
  
      if (enabled) {
        if (!hidden) {
          return (
            <>
             {
              !isVoicePlaying && (
                <Speech2Text setLoading={setLoading} handleSubmit={handleSubmit}/>
              )
             }
              {voiceMode.current === 'VOICE' && !isFirstMsg && (
                <DeepgramT2S 
                  interruptControllerRef={interruptControllerRef}
                  audioCtx={audioCtxRef.current!}
                  isVoicePlaying={isVoicePlaying}
                  setIsVoicePlaying={setIsVoicePlaying}/>
              )}
            </>
          )
        } else {
          return null;
        }
      } else {
        return (
          <div className={styles.contentWrapper}>
            <div onClick={handleMicClick} className={styles.micBtnWrapper} onTouchStart={handleMicClick}>
              <div className={styles.iconSlideUp}>
                <MicIcon />
              </div>
            </div>
          </div>
        )
      }
    }
  
    return (
      <>
        <audio ref={audioRef} src={(enabled) ? "mp3/mic-on-5WH4CSY7.mp3" : "mp3/mic-off-JEWTNSMK.mp3"} />
        {renderContent()}
      </>
    )
  }
)

export default DeepgramS2T